<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="24" height="24" rx="12" fill="white"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M5.60004 12.0001C5.60004 11.7056 5.83882 11.4668 6.13337 11.4668L17.8667 11.4668C18.1612 11.4668 18.4 11.7056 18.4 12.0001C18.4 12.2947 18.1612 12.5335 17.8667 12.5335L6.13337 12.5335C5.83882 12.5335 5.60004 12.2947 5.60004 12.0001Z" [attr.fill]="color"/>
</svg>
